import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { getStepDetails } from 'visa-store';
import * as i2 from 'app-services-library';

class APILetterGenerationEntry {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
}
APILetterGenerationEntry.ɵfac = function APILetterGenerationEntry_Factory(t) { return new (t || APILetterGenerationEntry)(i0.ɵɵinject(i1.HttpClient)); };
APILetterGenerationEntry.ɵprov = i0.ɵɵdefineInjectable({ token: APILetterGenerationEntry, factory: APILetterGenerationEntry.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APILetterGenerationEntry, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseLetterGenerationEntryLibraryService {
    constructor(store, appServicesLibraryService) {
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.redirectionComponent = new EventEmitter();
        this.disabledControls = false;
    }
    loadInit() {
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.stepDetails = data;
            this.toggleControlsStatus();
        });
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    handleSelection() {
        // console.log(this.templateValue);
        if (this.templateValue === 0) {
            this.redirectionComponent.emit("LetterTemplate");
        }
        else {
            this.redirectionComponent.emit("CreateTemplate");
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseLetterGenerationEntryLibraryService.ɵfac = function BaseLetterGenerationEntryLibraryService_Factory(t) { return new (t || BaseLetterGenerationEntryLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.AppServicesLibraryService)); };
BaseLetterGenerationEntryLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseLetterGenerationEntryLibraryService, factory: BaseLetterGenerationEntryLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseLetterGenerationEntryLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.AppServicesLibraryService }]; }, { redirectionComponent: [{
            type: Output
        }] }); })();

/*
 * Public API Surface of base-letter-generation-entry-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APILetterGenerationEntry, BaseLetterGenerationEntryLibraryService };
//# sourceMappingURL=base-letter-generation-entry-library.js.map
